// IE 2026 11 01 / ODOO-350449 (заказ Игоря: статуси-крапка, зони запасів, виконання планів — T12)
// Режим вида ячеек «Statuses: dot» (status_dot; uk «Статуси: крапка»): тот же разрез, что status_zones по st_val (статусы документов, остаток
// «No document», причины backlog / loss), но круг постоянного малого диаметра STATUS_DOT_D px рядом с числом, без шкалы (скрин dev02 -27
// «Баланс постачання та попиту» — мелкие кружки по статусам). Размер — cellRing_build opts.fixedDiameter (грид передаёт res.fixedDiameter);
// кольца сигналов (нехватка и т. п.) остаются, over-100 нет. «Statuses and zones» (status_zones) — круги по шкале, как прежде.
// Тесты — tests/unit/cellViewStatusDot.test.mjs
import { t as tI18n } from '@/i18n'
import { statusZones_statusLayers } from './statusZones'

export const STATUS_DOT_VIEW = 'status_dot'
export const STATUS_DOT_D = 8

const isObj = (o) => !!o && typeof o === 'object' && !Array.isArray(o)

export default {
    key: STATUS_DOT_VIEW,
    title: 'Statuses: dot',
    satellites: ['st_val'],
    needsData: true,
    // ctx: { t, date, measure, cell (= dataItem[date]), value (значение ячейки) }
    layersOf(dataItem, binding, ctx = {}) {
        const cell = ctx.cell
        if (!isObj(cell)) return null
        const sl = statusZones_statusLayers(cell.st_val, ctx.measure, ctx.value, ctx.t || tI18n, ctx.palette)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: p149 fix2-fe)
        if (!sl) return null
        return { layers: sl.layers, value: sl.value, satellite: 'st_val', fixedDiameter: STATUS_DOT_D }
    },
    tipOf(res, ctx = {}) {
        const t = ctx.t || tI18n
        return { caption: t('By document status') }
    },
}
